import AdminUsersList from '../../components/admin/AdminUsersList';
import PageContainer from '../../components/common/PageContainter';

const AdminSubscribers = () => {
    return (
        <PageContainer>
            <AdminUsersList />
        </PageContainer>
    );
};

export default AdminSubscribers;
